<template>
  <v-card class="pa-1 max-auto">
    <v-toolbar
      color="blue darken-3"
      class="text-center"
      cards
      dark
      flat
    >
    <v-icon>mdi-briefcase</v-icon>
    <span class="text-h6 text-align-left pl-2">
      Job Position Application Form
    </span>
     <v-spacer></v-spacer>
      <v-btn @click="$emit('close-dialog')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-form
      ref="form"
      v-model="form"
      v-on:submit.prevent="handleUpload"
    >
    <v-col>
      <v-row class="pt-3">
        <v-col cols="12">
          <v-text-field
            label="Insert Job Title Here"
            single-line
            show-size
            :rules="[rules.required]"
            v-model="title"
          ></v-text-field>
        </v-col>
      </v-row>
        <v-file-input
          :rules="rules.size"
          accept="image/png, image/jpeg, image/bmp"
          label="Upload your company logo"
          prepend-inner-icon="mdi-camera"
          small-chips
          prepend-icon=""
          v-model="uploadedLogo"
        ></v-file-input>
        <v-text-field
          :rules="[rules.required]"
          label="Company Website link (required)"
          prepend-inner-icon="mdi-link-variant"
          filled
          dense
          v-model="link"
        ></v-text-field>
        <v-textarea
          name="job description"
          filled
          label="Job Description"
          auto-grow
          v-model="description"
        ></v-textarea>
        <v-textarea
          name="key responsibilities"
          filled
          label="Key Responsibilities"
          auto-grow
          v-model="responsibilities"
        ></v-textarea>
        <v-textarea
          name="requirements"
          filled
          label="Required and preferred qualifications"
          auto-grow
          v-model="skills"
        ></v-textarea>
        <v-textarea
          name="application"
          filled
          label="How to submit Application"
          auto-grow
          v-model="instructions"
        ></v-textarea>
      </v-col>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-btn
        text
        @click="$refs.form.reset()"
      >
        Clear
      </v-btn>
      <v-spacer></v-spacer>
        <v-col>
          <v-btn
          :disabled="!form" :loading="isLoading" type="submit"
            class="white--text float-right"
            color="blue accent-4"
          >
            Submit
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-form>
    </v-card>
</template>
<script>
  import axios from 'axios';
  import { apiUrl } from '../config';

  export default {
    data: () => ({
      API_URL: apiUrl,
      form: false,
      isLoading: false,
      title: "",
      link: "",
      description: "[Deltailed the summary of the role, including its purpose, primary responsibilities and how it fits into the broarder ortganisational structure.]",
      responsibilities: "[A brief overview of the main tasks and duties the position requires.]",
      skills:"[List necessary skills, experiences and educational background. Additionally, add skills and experiences that are beneficial but not essential.]",
      instructions:"[Please let applicants know how to submit their Resume or CV.]",
      uploadedLogo: null,
      rules: {
          value:value => !value || value.size < 1000000 || 'Avatar size should be less than 2 MB!',
          required: v => !!v || 'This field is required',
      },
      dialog: false,
       
    }),
    methods: {
    async createJobPosition(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken);

        const response = await axios.post(`${this.API_URL}job-positions/`, formData, {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating business idea:', error);
        return false; // Failure
      }
    },

    //handle upload method
    async handleUpload() {
      // if (this.uploadLocation && this.uploadedText || this.uploadedLink || uploadedFiles) {
      // }

      this.isLoading = true

      const JobPositionData = {
        title: this.title,
        link: this.link,
        description: this.description,
        responsibilities: this.responsibilities,
        skills: this.skills,
        instructions: this.instructions,
        logo: this.uploadedLogo,
      };

      console.log('job position data from jonPosition.vue', JobPositionData);

      const formData = new FormData();
      formData.append('description', this.description);
      formData.append('company_logo', this.uploadedLogo);
      formData.append('title', this.title);
      formData.append('website_link', this.link);
      formData.append('responsibilites', this.responsibilities);
      formData.append('skills', this.skills);
      formData.append('submission_instructions', this.instructions);
      
      const isSuccess = await this.createJobPosition(formData);
      this.$emit('handle-toggle-form');
      // Emit events only if the API call is successful (status code 201)
      if (isSuccess) {
        this.$emit('fetch-job-positions');
      }

      this.isLoading = false
    },

  },
  }
</script>